import { useContext } from 'react';
import { MainContext } from '../context/main.context';
import { deleteUserAuthDataId, getIframeSrcOrigin, getSession } from '../common/tools';
import { toast } from 'react-toastify';
import { IWebAuthData } from '../interfaces';
import { GAME_IFRAME_ID } from '../common/constants';

export type REDIRECT_TYPE =
    'auth'|
    'payment'|
    'error'|
    'cancelledAuth'|
    'cancelledPayment'|
    'authExist'|
    'authNotExist'|
    'unauthorized'|
    'unknown' |
    'support';

const PATH: string = window.location.origin;
const LOGIN_DONE_PATH: string[] = ['auth', 'authExist', 'authNotExist'];
const PAYMENT_PATH: string[] = ['payment'];
const UNAUTHORIZED_PATH: string[] = ['unauthorized'];


export default function ManualController() {
    const { settings, modalContent, setModalContent, setUserAuth, getSupportUnreadMessageCountPublic } = useContext(MainContext);

    const manualRedirect = (
        data: any = {},
        origin: REDIRECT_TYPE = 'unknown',
        isError: boolean = false,
        errorCode: number = 0,
        manualAuthType: 'redirect' | 'postMessage' | 'browser' | '' = '',
    ): void => {
        const authType: string = settings?.projects?.authType || manualAuthType;
        const iframe = document.getElementById(GAME_IFRAME_ID) as HTMLIFrameElement;

        if (authType === 'postMessage') {
            if (origin === 'auth') {
                if (data && !errorCode && !isError) {
                    const { currentAuthType, jwt, nickName, userId } = data;

                    const userAuthData: IWebAuthData = {
                        currentAuthType,
                        nickName,
                        userId,
                        jwt,
                        session: getSession(),
                    }

                    setUserAuth(userAuthData, jwt);
                    deleteUserAuthDataId();

                    if (iframe && iframe.contentWindow) {
                        const type: string = 'PLAYHUB_TO_IFRAME_USER_AUTH';
                        const text: string = JSON.stringify(userAuthData);

                        iframe.contentWindow.postMessage({ type, text }, getIframeSrcOrigin());
                    }

                    getSupportUnreadMessageCountPublic();
                } else {
                    console.error('MANUAL_REDIRECT_ERROR', { authType, origin, data, isError, errorCode });
                    toast.error('MANUAL_REDIRECT_ERROR');
                }
            } else if (origin === 'payment') {
                if (iframe && iframe.contentWindow) {
                    const type: string = 'PLAYHUB_TO_IFRAME_PAYMENT_RESULT';
                    const text: string = JSON.stringify({ data, type: origin, isError, errorCode });

                    iframe.contentWindow.postMessage({ type, text }, getIframeSrcOrigin());
                }
            }

            if (modalContent) {
                setModalContent(null);
            }

            return;
        }

        if (authType === 'redirect') {
            deleteUserAuthDataId();

            redirectToGame(data, origin, isError, errorCode);
            return;
        }

        console.error('MANUAL_REDIRECT_ERROR', { authType, origin, data, isError, errorCode });
        toast.error('MANUAL_REDIRECT_UNKNOWN_AUTH_TYPE');
    }

    return {
        manualRedirect,
    };
}

export const redirectToGame = (data: any, type: REDIRECT_TYPE, isError: boolean, errorCode: number): void => {
    let pathname: string = '';

    if (LOGIN_DONE_PATH.includes(type)) {
        pathname = '/session/loginDone';
    } else if (PAYMENT_PATH.includes(type)) {
        pathname = '/payments/done';
    } else if (UNAUTHORIZED_PATH.includes(type)) {
        pathname = '/unauthorized';
    } else if (type === 'support') {
        pathname = '/support/done';
    }

    const resultStr: string = JSON.stringify({
        data,
        type,
        isError,
        errorCode,
    });

    const result: string = encodeURIComponent(resultStr);

    window.location.href = `${PATH}${pathname}?result=${result}`;
}